import { render } from "./promotion.vue?vue&type=template&id=88b18994&ts=true"
import script from "./promotion.vue?vue&type=script&lang=ts"
export * from "./promotion.vue?vue&type=script&lang=ts"

import "./promotion.vue?vue&type=style&index=0&id=88b18994&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__